import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "dtwin-rule-metrics"
  }, _vm._l(_vm.rule.properties.stateMetrics, function (stateMetric, i) {
    return _c('core-n20Card', {
      key: `statemetric_${i}`,
      class: `dt-card-text-01 ${i === 0 ? 'mt-12' : ''}`,
      scopedSlots: _vm._u([{
        key: "buttons",
        fn: function () {
          return [!_vm.disabled ? _c(VBtn, {
            class: 'v-btn-x mx-1 v-btn--rounded bg-rounded-button-' + _vm.color,
            attrs: {
              "color": _vm.color,
              "title": _vm.$i18n_t('Common.delete'),
              "icon": "",
              "info": "",
              "fab": "",
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.$emit('delete-state', i);
              }
            }
          }, [_c(VIcon, {
            attrs: {
              "dark": ""
            }
          }, [_vm._v("fal fa-trash-alt")])], 1) : _vm._e(), !_vm.disabled ? _c(VBtn, {
            class: 'v-btn-x mx-1 v-btn--rounded bg-rounded-button-' + _vm.color,
            attrs: {
              "color": _vm.color,
              "title": _vm.$i18n_t('Common.addNew'),
              "icon": "",
              "info": "",
              "fab": "",
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.$emit('add-state', i);
              }
            }
          }, [_c(VIcon, {
            attrs: {
              "dark": ""
            }
          }, [_vm._v("fal fa-plus")])], 1) : _vm._e()];
        },
        proxy: true
      }], null, true)
    }, [_c(VRow, [_vm.templateContext ? _c(VCol, {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c(VSelect, {
      staticClass: "required",
      attrs: {
        "items": _vm.states,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.requiredRule,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.metricState'),
        "item-text": "properties.title",
        "item-value": "id",
        "hide-details": "auto",
        "required": "",
        "data-cy": "statemetric_id"
      },
      on: {
        "change": function ($event) {
          return _vm.$emit('state-selected', stateMetric);
        }
      },
      scopedSlots: _vm._u([{
        key: "selection",
        fn: function (data) {
          return [_vm._v("\n            " + _vm._s(data.item.properties.title) + "\n            "), !_vm.templateContext ? _c('span', [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")")]) : _vm._e()];
        }
      }, {
        key: "item",
        fn: function (data) {
          return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n                " + _vm._s(data.item.properties.title) + "\n                "), !_vm.templateContext ? _c('span', [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")")]) : _vm._e()]), _c(VListItemSubtitle, {
            domProps: {
              "innerHTML": _vm._s(data.item.key)
            }
          })], 1)];
        }
      }, {
        key: "append-outer",
        fn: function () {
          return [stateMetric.stateId && !_vm.templateContext ? _c(VBtn, {
            class: `my-0 v-btn-x v-btn--rounded bg-rounded-button-${_vm.color}`,
            attrs: {
              "color": _vm.color,
              "icon": "",
              "info": "",
              "fab": "",
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.openDigitalTwinOfState(stateMetric.stateId);
              }
            }
          }, [_c(VIcon, {
            attrs: {
              "color": _vm.color,
              "dark": "",
              "small": "",
              "title": _vm.stateTitle(stateMetric),
              "alt": _vm.stateTitle(stateMetric)
            }
          }, [_vm._v("\n                fal fa-info-circle\n              ")])], 1) : _vm._e()];
        },
        proxy: true
      }], null, true),
      model: {
        value: stateMetric.id,
        callback: function ($$v) {
          _vm.$set(stateMetric, "id", $$v);
        },
        expression: "stateMetric.id"
      }
    })], 1) : _c(VCol, {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c(VSelect, {
      staticClass: "required",
      attrs: {
        "disabled": _vm.disabled,
        "items": _vm.states,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.requiredRule,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.metricState'),
        "item-text": "properties.title",
        "item-value": "id",
        "hide-details": "auto",
        "data-cy": "statemetric_id",
        "required": ""
      },
      on: {
        "change": function ($event) {
          return _vm.$emit('state-selected', stateMetric);
        }
      },
      scopedSlots: _vm._u([{
        key: "selection",
        fn: function (data) {
          return [_vm._v("\n            " + _vm._s(data.item.properties.title) + "\n            "), !_vm.templateContext ? _c('span', [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")")]) : _vm._e()];
        }
      }, {
        key: "item",
        fn: function (data) {
          return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n                " + _vm._s(data.item.properties.title) + "\n                "), !_vm.templateContext ? _c('span', [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")")]) : _vm._e()]), _c(VListItemSubtitle, {
            domProps: {
              "innerHTML": _vm._s(data.item.key)
            }
          })], 1)];
        }
      }, {
        key: "append-outer",
        fn: function () {
          return [stateMetric.stateId && !_vm.templateContext ? _c(VBtn, {
            class: `my-0 v-btn-x v-btn--rounded bg-rounded-button-${_vm.color}`,
            attrs: {
              "color": _vm.color,
              "icon": "",
              "info": "",
              "fab": "",
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.openDigitalTwinOfState(stateMetric.stateId);
              }
            }
          }, [_c(VIcon, {
            attrs: {
              "color": _vm.color,
              "dark": "",
              "small": "",
              "title": _vm.stateTitle(stateMetric),
              "alt": _vm.stateTitle(stateMetric)
            }
          }, [_vm._v("\n                fal fa-info-circle\n              ")])], 1) : _vm._e()];
        },
        proxy: true
      }], null, true),
      model: {
        value: stateMetric.stateId,
        callback: function ($$v) {
          _vm.$set(stateMetric, "stateId", $$v);
        },
        expression: "stateMetric.stateId"
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c(VTextField, {
      staticClass: "required",
      attrs: {
        "disabled": _vm.disabled,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.stateMetricKeyUnique,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.metricAlias'),
        "required": "",
        "hide-details": "auto"
      },
      on: {
        "input": function ($event) {
          return _vm.$emit('validate-form');
        }
      },
      model: {
        value: stateMetric.key,
        callback: function ($$v) {
          _vm.$set(stateMetric, "key", $$v);
        },
        expression: "stateMetric.key"
      }
    })], 1)], 1), _c(VRow, {
      staticClass: "dtwin-rule-statemetric-history"
    }, [_c(VCol, {
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "4"
      }
    }, [_c(VTextField, {
      attrs: {
        "disabled": _vm.disabled || stateMetric.operation === 'since_last_update',
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.historyMinutes', {
          n: stateMetric.history.minutes
        }),
        "type": "number",
        "hide-details": ""
      },
      scopedSlots: _vm._u([{
        key: "prepend",
        fn: function () {
          return [_c(VCheckbox, {
            attrs: {
              "color": _vm.color,
              "disabled": stateMetric.operation === 'since_last_update',
              "hide-details": ""
            },
            model: {
              value: stateMetric.history.useMinutes,
              callback: function ($$v) {
                _vm.$set(stateMetric.history, "useMinutes", $$v);
              },
              expression: "stateMetric.history.useMinutes"
            }
          })];
        },
        proxy: true
      }], null, true),
      model: {
        value: stateMetric.history.minutes,
        callback: function ($$v) {
          _vm.$set(stateMetric.history, "minutes", _vm._n($$v));
        },
        expression: "stateMetric.history.minutes"
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "4"
      }
    }, [_c(VTextField, {
      attrs: {
        "disabled": _vm.disabled || !_vm.stateIsNumeric(stateMetric) || stateMetric.operation === 'since_last_update',
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.historyCount', {
          n: stateMetric.history.count
        }),
        "type": "number",
        "hide-details": ""
      },
      scopedSlots: _vm._u([{
        key: "prepend",
        fn: function () {
          return [_c(VCheckbox, {
            attrs: {
              "color": _vm.color,
              "disabled": stateMetric.operation === 'since_last_update',
              "hide-details": ""
            },
            model: {
              value: stateMetric.history.useCount,
              callback: function ($$v) {
                _vm.$set(stateMetric.history, "useCount", $$v);
              },
              expression: "stateMetric.history.useCount"
            }
          })];
        },
        proxy: true
      }], null, true),
      model: {
        value: stateMetric.history.count,
        callback: function ($$v) {
          _vm.$set(stateMetric.history, "count", _vm._n($$v));
        },
        expression: "stateMetric.history.count"
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "4"
      }
    }, [_c(VCheckbox, {
      attrs: {
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.historyAbortIfNull'),
        "color": _vm.color,
        "disabled": _vm.disabled,
        "hide-details": ""
      },
      model: {
        value: stateMetric.history.abortIfNull,
        callback: function ($$v) {
          _vm.$set(stateMetric.history, "abortIfNull", $$v);
        },
        expression: "stateMetric.history.abortIfNull"
      }
    })], 1)], 1), _c(VRow, [_c(VCol, {
      staticClass: "pb-0 mb-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('p', {
      staticClass: "card-description pb-0 mb-1",
      domProps: {
        "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.operationText'))
      }
    })]), _c(VCol, {
      attrs: {
        "cols": "12",
        "sm": "5",
        "md": "4"
      }
    }, [_c(VSelect, {
      staticClass: "required",
      attrs: {
        "disabled": _vm.disabled,
        "items": _vm.editRuleOperationsForMetric(stateMetric),
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.operation'),
        "hide-details": ""
      },
      scopedSlots: _vm._u([{
        key: "prepend",
        fn: function () {
          return [_vm._v("1.")];
        },
        proxy: true
      }], null, true),
      model: {
        value: stateMetric.operation,
        callback: function ($$v) {
          _vm.$set(stateMetric, "operation", $$v);
        },
        expression: "stateMetric.operation"
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "12",
        "sm": "7",
        "md": "8"
      }
    }, [_c(VTextField, {
      staticClass: "math-transform-field",
      attrs: {
        "disabled": _vm.disabled,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.stateMetricTransformerValid,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.transformer'),
        "hide-details": "auto"
      },
      on: {
        "blur": function ($event) {
          return _vm.evaluateTransformer(stateMetric);
        }
      },
      scopedSlots: _vm._u([{
        key: "prepend",
        fn: function () {
          return [_vm._v("2.")];
        },
        proxy: true
      }, {
        key: "prepend-inner",
        fn: function () {
          return [_c('div', {
            staticStyle: {
              "display": "flex",
              "flex": "1 1 auto",
              "align-items": "center"
            }
          }, [_c('div', [_vm._v("TRANSFORM(x => return")])])];
        },
        proxy: true
      }, {
        key: "append",
        fn: function () {
          return [_c('div', {
            staticStyle: {
              "display": "flex",
              "flex": "1 1 auto",
              "align-items": "center"
            }
          }, [_c('div', [_vm._v(")")])])];
        },
        proxy: true
      }], null, true),
      model: {
        value: stateMetric.transform,
        callback: function ($$v) {
          _vm.$set(stateMetric, "transform", $$v);
        },
        expression: "stateMetric.transform"
      }
    })], 1)], 1)], 1);
  }), 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };